import { ClaimRecord } from '@typesApp/ClaimRecord'
import { QuoteStatus, QuoteStatusSummary, QuoteCustomerFacingStatus, QuoteErrorData } from '@typesApp/QuoteData'
import { QuoteDetails } from '@typesApp/QuoteDetails'
import { config } from '@config/config'
import { formatPrice } from './formatPrice'

export const getLastQuoteStatusSummary = (claimRecord?: ClaimRecord): QuoteStatusSummary => {
  const lastResult = claimRecord?.claimData?.quoteSummaries?.find(s => s.lastQuote)
  return lastResult
    ? {
        ...lastResult,
        claimRecordStatus: claimRecord?.status,
      }
    : {
        status: claimRecord?.claimData?.quote?.status ?? QuoteStatus.NONE,
        customerFacingStatus: claimRecord?.claimData?.quote?.customerFacingStatus ?? QuoteCustomerFacingStatus.NONE,
        errorType: claimRecord?.claimData?.quote?.errorType,
        errorCode: claimRecord?.claimData?.quote?.errorCode,
        errorMessage: claimRecord?.claimData?.quote?.errorMessage,
        claimRecordStatus: claimRecord?.status,
      }
}

const getQuoteErrorData = (claimRecord: ClaimRecord): QuoteErrorData | undefined => {
  const quote = claimRecord?.claimData?.quote
  return (
    quote && {
      errorType: quote?.errorType,
      errorCode: quote?.errorCode,
      errorMessage: quote?.errorMessage,
    }
  )
}

export const getQuoteDetails = (claimRecord: ClaimRecord): QuoteDetails => {
  const quote = claimRecord?.claimData?.quote
  const subtotal = claimRecord?.orderSubtotal?.amount ?? 0
  const confirmed = claimRecord.claimData?.quote?.quoteConfirmedAmount?.amount ?? 0

  // free shipping by default unless disabled for brand
  const disableFreeShipping = config.getFeatures()?.disableQuoteFreeShipping
  const shipping = !disableFreeShipping ? 0 : (quote?.shippingCosts?.amount ?? 0)
  const isFreeShipping = shipping === 0

  return {
    status: quote?.status || QuoteStatus.NONE,
    insurerName: quote?.primaryCoverage?.insurer?.name || '',
    orderSubtotal: formatPrice(subtotal),
    shippingCosts: formatPrice(shipping),
    residualAmount: formatPrice(subtotal + shipping - confirmed),
    requestedAmount: formatPrice(confirmed),
    confirmedAmount: formatPrice(confirmed),
    isFreeShipping,
    error: getQuoteErrorData(claimRecord),
  }
}
